import OutputSimulatorContainer from './OutputSimulatorContainer'

export default OutputSimulatorContainer
